<div id="advanced-deal-container" class="tw-flex tw-flex-col tw-h-auto">
  <app-deal-alerts [dealId]="deal.id"></app-deal-alerts>
  
  <!-- Top bar with tabs and action buttons -->
  <div class="tw-flex tw-justify-between tw-items-end tw-px-4 tw-py-2 tw-border-b tw-border-gray-200 tw-bg-white tw-min-h-[48px]">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" class="tw-flex-1" #tabGroup>
      <mat-tab data-cy="advanced-deal-approval-offers-tab" label="Approval & Offers"></mat-tab>
      <mat-tab data-cy="advanced-deal-documents-tab" label="Deal Docs"></mat-tab>
      <mat-tab data-cy="advanced-deal-details-tab" label="Details"></mat-tab>
    </mat-tab-group>
    
    <!-- Action buttons on the right side of the top bar -->
    <div class="tw-flex tw-gap-2 tw-ml-4 tw-mb-1">
      <app-deal-actions-smart
        [deal]="deal"
        [offers]="offers"
        [applications]="applications"
        [bulkSubmitting]="bulkSubmitting"
        (submit)="submit.emit($event)"
        [advancedDeal]="true">
      </app-deal-actions-smart>
    </div>
  </div>
  
  <!-- Main content area -->
  <div class="tw-flex tw-flex-1">
    <div class="tw-flex tw-flex-col tw-flex-1 tw-p-4 tw-overflow-y-auto">
      <!-- Tab content rendered separately -->
       @if (tabGroup.selectedIndex === 0) {
        <div>
          <app-approvals-and-offers
            [deal]="deal"
            [approvalsLoading]="approvalsLoading()"
            [canSeeFunctionalApprovals]="canSeeFunctionalApprovals()"
            [canRecommendOptions]="canRecommendOptions"
            [approvals]="approvals" 
            [offerOptions]="offerOptions"
            [deal]="deal" 
            [readOnly]="readOnly"
            [canRecommendOptions]="canRecommendOptions"
            [canSeeFunctionalApprovals]="canSeeFunctionalApprovals"
            [hasContractRequest]="hasContractRequest"
            [advancedDeal]="true">
          </app-approvals-and-offers>
        </div>
      }
      @if (tabGroup.selectedIndex === 1) {
        <div *ngIf="tabGroup.selectedIndex === 1">
          <app-documents-grid data-cy="advanced-deal-documents-component"
                          [borrowerId]="deal.borrowerId"
                          [dealId]="deal.id" 
                          [loanProductCategory]="deal.loanProductCategory"
                          [documentCategories]="documentCategories()"
                          [documents]="dealDocuments()"
                          [borrowerDocuments]="borrowerDocuments()"
                          [authUser]="currentUser()">
          </app-documents-grid>
        </div>
      }
      @if (tabGroup.selectedIndex === 2) {
        <div *ngIf="tabGroup.selectedIndex === 2">
          <app-advanced-deal-details
            [deal]="deal"
            [approvals]="approvals"
            [applications]="applications"
            [closerName]="closer()"
            [readOnly]="readOnly">
          </app-advanced-deal-details>
        </div>
      }
    </div>
    
    <!-- Right sidebar with document requirements -->
    <div id="advanced-deal-sidebar-container" class="tw-flex tw-flex-col tw-w-[25%] tw-bg-gray-50 tw-border-l tw-border-gray-200 tw-bg-white">
      <div class="tw-border-b tw-border-gray-200 tw-p-4">
        <app-deal-app-status-smart 
          [loadingStatus]="appQuestionsLoading" 
          [questionListStatus]="questions" 
          [deal]="deal"
          [borrowerId]="deal.borrowerId"
          [advancedDeal]="true">
        </app-deal-app-status-smart>
      </div>
      <app-document-requirements [deal]="deal" class="tw-flex-1 tw-overflow-y-auto tw-p-4"></app-document-requirements>
    </div>
  </div>
</div>
